import React from 'react';

import SiteNavLink from '../buttons/SiteNavLink/SiteNavLink';

export default function SiteNavigation() {
  const footerSiteNavigation = [
    { to: '/', isHLeftAligned: true, label: 'Home' },
    { to: '/our-process', isHLeftAligned: true, label: 'Our Process' },
    { to: '/our-team', isHLeftAligned: true, label: 'Our Team' },
    { to: '/our-services', isHLeftAligned: true, label: 'Our Services' },
    { to: '/conditions', isHLeftAligned: true, label: 'Conditions Treated' },
    { to: '/rates', isHLeftAligned: true, label: 'Billing' },
    { to: '/products', isHLeftAligned: true, label: 'Product' },
    { to: '/blog', isHLeftAligned: true, label: 'Blog' },
    { to: '/contact-us', isHLeftAligned: true, label: 'Contact Us' },
    { to: '/faq', isHLeftAligned: true, label: 'FAQ' },
    {
      to: '/free-consultation',
      isHLeftAligned: true,
      label: 'Free 10 Min Consult',
    },
  ];

  return (
    <>
      <div className='site-nav'>
        <h4 className='site-nav-header'>Site Navigation</h4>
        <div className='site-nav-links'>
          {footerSiteNavigation.map((nav, i) => (
            <SiteNavLink
              key={i}
              destination={nav.to}
              isHLeftAligned={nav.isHLeftAligned}
            >
              {nav.label}
            </SiteNavLink>
          ))}
        </div>
      </div>
    </>
  );
}
